import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { PassesForSaleFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPassesForSalePOSTErrorResponse, ParkPassesForSalePOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const fetchPassesForSale = async (): Promise<ParkPassesForSalePOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPassesForSalePOSTSuccessResponse>("/passes-for-sale");
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPassesForSalePOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: PassesForSaleFailReason };
  }
};
